export const userparameterConstants = {
    GETALL_REQUEST: 'USERPARAMETER_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERPARAMETER_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERPARAMETER_GETALL_FAILURE',

    DELETE_REQUEST: 'USERPARAMETER_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERPARAMETER_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERPARAMETER_DELETE_FAILURE'
};
